import React from 'react';
import '../../styles/components/ModalBodyBulkSelect.scss';
import { AsperaDataTable } from '../AsperaDataTable';
import { iterableToArray } from '../../helpers/helpers';
import { Button, Search } from '../Carbon';
import { language } from '../../services/LanguageService';
import { Subject } from 'rxjs';
import { AsperaTableData } from '../../classes/AsperaTableData';
import { withRouter } from 'react-router-dom';
/**
 * React Component
 *
 * The ModalBodyBulkSelect provides a basic template for showing a bulk select modal (mostly used for AsperaAutocomplete Action Button)
 *
 * @example
 * ```javascript
 * <ModalBodyBulkSelect apiData={apiData} headerData={headerData} modalClose={modalClose} />
 * ```
 */
export const ModalBodyBulkSelect = withRouter(class ModalBodyBulkSelect extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            viewSelected: false,
            filterText: '',
        };
        this.selectedItems = new Map();
        this.filterSub = new Subject();
        this.tableId = 'AsperaModalBulkSelect-Table';
        this.toggleView = () => {
            const { viewSelected } = this.state;
            if (!viewSelected && !this.selectedItems.size)
                return;
            this.setState({ viewSelected: !viewSelected });
        };
        this.searchChange = (event) => {
            var _a;
            const filterText = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.value) || '';
            this.filterSub.next(filterText);
            this.setState({ filterText });
        };
    }
    get idToUse() {
        const { itemIdKey } = this.props;
        return itemIdKey || 'id';
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        modalClose({ items: iterableToArray(this.selectedItems.values()) });
    }
    componentDidMount() {
        const { initialItemList } = this.props;
        const tableData = new AsperaTableData(this.tableId);
        if (tableData.filterText) {
            this.setState({ filterText: tableData.filterText });
        }
        if (Array.isArray(initialItemList)) {
            initialItemList.forEach(item => {
                this.selectedItems.set(item[this.idToUse], item);
            });
            this.setState({});
        }
    }
    render() {
        const { viewSelected, filterText } = this.state;
        const { className, apiData, headerData, errorProps, emptyProps, searchEmptyProps, alterDataStore, nextPagingKey, defaultSortKey, initialItemList } = this.props;
        return (React.createElement("div", { className: `modal-body-bulk-select ${className ? className : ''}` },
            React.createElement("div", { className: "modal-body-bulk-select--controls" },
                React.createElement(Button, { className: "controls-action", kind: "tertiary", size: "sm", onClick: this.toggleView, "data-auto": "modal-body-bulk-select-toggle-view" }, language.get(viewSelected ? 'table.back' : 'table.itemSelected', [this.selectedItems.size])),
                !viewSelected && React.createElement(Search, { labelText: "", defaultValue: filterText, onChange: this.searchChange, size: "sm", placeholder: language.get('table.search'), "data-auto": "modal-body-bulk-select-search-box" })),
            React.createElement(AsperaDataTable, { tableId: this.tableId, className: "modal-body-bulk-select--table-wrapper", disableFilter: true, externalFilterSub: this.filterSub.asObservable(), showSelectedItems: viewSelected, apiData: apiData, itemIdKey: this.idToUse, headerData: headerData, errorProps: errorProps, emptyProps: emptyProps, searchEmptyProps: searchEmptyProps, initiallySelectedItems: initialItemList, alterDataStore: alterDataStore, nextPagingKey: nextPagingKey, genericTable: true, defaultSortKey: defaultSortKey, onBatchChange: (items) => {
                    this.selectedItems.clear();
                    items.forEach(item => {
                        this.selectedItems.set(item[this.idToUse], item);
                    });
                    this.setState({});
                } })));
    }
});
